<div class="notification-title display-flex align-items-center no-wrap" mat-dialog-title>
  {{ dialogTitle }}
</div>

<mat-dialog-content>
  <div class="notification-modal">
    <div [formGroup]="form" class="display-flex flex-column grid-gap-16">
      <div class="display-flex flex-column grid-gap-4">
        <div class="flex-1">
          <app-input
            class="flex-grow-1"
            [matFormCss]="'border-radius-partial-left'"
            [attrLabel]="'Name'"
            [attrPlaceholder]="'Enter name'"
            formControlName="name"
            [labelRequired]="true"
            [showValidationError]="submitted"></app-input>
        </div>

        <div class="display-flex grid-gap-4 pl-4">
          <div class="display-flex align-items-center grid-gap-16 content-warning">
            <div
              class="display-flex flex-column align-items-center justify-content-center grid-gap-2 content-warning-icon">
              <div class="content-warning-icon-line"></div>
              <div class="content-warning-icon-dot"></div>
            </div>
          </div>
          <div class="ticket-type-description">{{ ticketTypeDescription$ | async }}</div>
        </div>
      </div>

      <ng-container *ngIf="!isEditMode">
        <ng-container *ngIf="form.get('notifyAssignee')?.value === DynamicTicketTypeNotifyAssigneeMode.Custom">
          <div class="flex-1">
            <app-radio-button-dropdown
              class="flex-grow-1"
              [containerCss]="'w-100'"
              [items]="notifyOptions"
              label="Notify on"
              formControlName="notifyOn"
              [allowClear]="false"
              [allowSearch]="false"
              [autoSortList]="false"
              [showValidationError]="false"
              [labelRequired]="false"
              [attrPlaceholder]="'On due date'"
              attrAppendTo="body"></app-radio-button-dropdown>
          </div>
          <div class="flex-1 display-flex gap-12">
            <app-radio-button-dropdown
              class="flex-grow-1"
              [containerCss]="'w-100'"
              [items]="remindOnOptions"
              label="Remind on"
              formControlName="remindOn"
              [allowClear]="false"
              [allowSearch]="false"
              [autoSortList]="false"
              [showValidationError]="false"
              [labelRequired]="false"
              [attrPlaceholder]="'On due date'"
              attrAppendTo="body"></app-radio-button-dropdown>
            <app-radio-button-dropdown
              class="flex-grow-1"
              [containerCss]="'w-100'"
              [items]="untilOptions"
              label="Until"
              formControlName="until"
              [allowClear]="false"
              [allowSearch]="false"
              [autoSortList]="false"
              [showValidationError]="false"
              [labelRequired]="false"
              [attrDisable]="remindOn.value === DontNotifyId"
              [attrPlaceholder]="'On due date'"
              attrAppendTo="body"></app-radio-button-dropdown>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="display-flex justify-content-space-between w-100">
    <button mat-stroked-button color="primary" type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="save()">Done</button>
  </div>
</mat-dialog-actions>
